import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Global routes
export const globalIntegrationCreateRoute: InvariantJiraRoute = {
	name: 'eoc-integration-create',
	path: '/jira/settings/products/ops/integrations/create/:type',
	exact: true,
};
